import { createReducer, on } from '@ngrx/store';
import { EStateStatus } from '@app/app.state';
import { compareObjects } from 'mt-ui-lib/functions';
import { IApiError } from '@app/core/interfaces/error';
import { HttpErrorResponse } from '@angular/common/http';
import { SystemParamsActions } from './system-params.actions';
import { ISystemParam } from '@app/core/interfaces/system-params';

export interface ISystemParamState {
  source: string | null;
  id: string | 'new';
  param: ISystemParam;
  form: Partial<ISystemParam>;
  hasChanges: boolean;
  status: EStateStatus;
  error: HttpErrorResponse & { error: IApiError };
}
export const initialState: ISystemParamState = {
  source: null,
  id: null,
  param: null,
  form: null,
  hasChanges: false,
  status: EStateStatus.PENDING,
  error: null,
};

export const SystemParamsReducer = createReducer(
  initialState,
  on(SystemParamsActions.activateSource, (_, payload) => ({
    ...initialState,
    source: payload.source,
  })),
  on(SystemParamsActions.selectParam, (state, payload) =>
    state.source === payload.source
      ? {
          ...state,
          id: payload.id,
          param: null,
          form: null,
          hasChanges: false,
          status: EStateStatus.SUCCESS,
          error: null,
        }
      : state,
  ),
  on(SystemParamsActions.clearParam, (state, payload) =>
    state.source === payload.source
      ? {
          ...state,
          id: null,
          param: null,
          form: null,
          hasChanges: false,
          status: EStateStatus.PENDING,
          error: null,
        }
      : state,
  ),
  // Получение
  on(SystemParamsActions.requestParamInfo, (state, payload) =>
    state.source === payload.source
      ? { ...state, status: EStateStatus.LOADING }
      : state,
  ),
  on(SystemParamsActions.requestParamInfoSuccess, (state, payload) =>
    state.source === payload.source
      ? {
          ...state,
          param: payload.param,
          status: EStateStatus.SUCCESS,
        }
      : state,
  ),
  on(SystemParamsActions.requestParamInfoError, (state, payload) =>
    state.source === payload.source
      ? {
          ...state,
          error: payload.error,
          status: EStateStatus.ERROR,
        }
      : state,
  ),
  // Изменение
  on(SystemParamsActions.requestUpdateParam, (state, payload) =>
    state.source === payload.source
      ? { ...state, status: EStateStatus.LOADING }
      : state,
  ),
  on(SystemParamsActions.requestUpdateParamSuccess, (state, payload) =>
    state.source === payload.source
      ? {
          ...state,
          hasChanges: false,
          status: EStateStatus.SUCCESS,
        }
      : state,
  ),
  on(SystemParamsActions.requestUpdateParamError, (state, payload) =>
    state.source === payload.source
      ? {
          ...state,
          error: payload.error,
          status: EStateStatus.ERROR,
        }
      : state,
  ),
  on(SystemParamsActions.setFormValues, (state, payload) => {
    if (state.source !== payload.source) return state;
    const hasChanges: boolean = !compareObjects(
      payload.form,
      state.param,
      false,
    );

    return {
      ...state,
      form: payload.form,
      hasChanges,
      status:
        state.status === EStateStatus.LOADING
          ? EStateStatus.LOADING
          : EStateStatus.PENDING,
    };
  }),
);
